import { NgModule } from '@angular/core';

import { PhonePipe } from '@modules/shared/pipes/phone/phone.pipe';
import { SharedModule } from '@modules/shared/shared.module';

import { ExistingUserDialogComponent } from './existing-user-dialog.component';

@NgModule({
  declarations: [ExistingUserDialogComponent],
  imports: [SharedModule, PhonePipe]
})
export class ExistingUserDialogModule {}
